<!-- 
  Set roundingType="floor" to have the same values like HMI
  Set roundingType="round" to have the same values like ViCare & ViStart
 -->
<div #container class="curve-wrapper">
  <vi-graph
    data-at-graph
    labelX="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_CURVE.PLOT.LABEL_X' | translate }} ({{
      degree
    }}{{ labelUnit }})"
    labelY="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_CURVE.PLOT.LABEL_Y' | translate }} ({{
      degree
    }}{{ labelUnit }})"
    [graphWidth]="graphWidth"
    [graphHeight]="graphHeight"
    [data]="data"
    [minX]="minOutsideTemperature"
    [maxX]="maxOutsideTemperature"
    [gapX]="gapX"
    [minY]="0"
    [maxY]="100"
    [gapY]="gapY"
    [maxFlowTemperature]="maxFlowLimitTemperature"
    [isFlowTemperatureAvailable]="isFlowTemperatureAvailable"
    [reverse]="true"
    [unit]="'°'"
    [edgeValues]="true"
    roundingType="round"
    [converter]="bindConvertToFahrenheit"
  ></vi-graph>
</div>
